import axios from "axios";
import env from "../Env";
import moment from "moment";
export default {
  generateTemplates: function(token, country, baaNdaData) {
    return new Promise((resolve, reject) => {
      let documentType = "baa";
      let url = `${process.env.VUE_APP_baseUrl}baanda/${country}`;
      axios
        .put(url, baaNdaData, { headers: { Authorization: `${token}` } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
};
